import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AnimatedBackground from './components/AnimatedBackground';
import Header from './components/Header';
import Hero from './sections/Hero';
import About from './sections/About';
import Skills from './sections/Skills';
import Projects from './sections/Projects';
import Experience from './sections/Experience';
import Education from './sections/Education';
import Publications from './sections/Publications';
import Resume from './sections/Resume';
import Contact from './sections/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import ErrorBoundary from './components/ErrorBoundary';

const Portfolio = () => {
  return (
    <div className="relative min-h-screen bg-slate-900">
      <AnimatedBackground />
      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <About />
          <Skills />
          <Projects />
          <Publications />
          <Experience />
          <Education />
          <Resume />
          <Contact />
        </main>
        <Footer />
      </div>
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;